<div class="py-3">
    <div *ngIf="healthStatus.status==='KO'" class="alert alert-danger" role="alert">
      {{ i18n.info.alert1 }}
    </div>
</div>

<div class="py-3">
  <div *ngIf="formioError" class="alert alert-danger h4 text-center" role="alert">
    {{ i18n.info.alert2 }}
  </div>
</div>

<div appRemoveAfter="4000" *ngIf="load==='OK'" class="alert alert-info">
    {{ i18n.info.alert3 }} {{data_salvataggio}}
</div>

<div appRemoveAfter="3000" *ngIf="saving==='OK'" class="alert alert-success">
  {{ i18n.salvato_in_bozza }}
</div>

<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" rejectButtonStyleClass="p-button-text"
 acceptLabel="Sì"
 rejectLabel="No">
 </p-confirmDialog>

 <div>
    <formio #formElemnet
      [src]="src"
      [renderOptions]="renderOptions"
      [options]="options"
      (submit)="onSubmit($event)"
      (change)="onChange($event)"
      (invalid)="onSubmit($event)"
      (customEvent)="customEvent($event)"
      (render)="onRender(formElemnet)"
      [form]="myform"
      [refresh]="refreshForm"
      (formLoad)="formLoad($event)"
      (nextPage)="onTop()" (prevPage)="onTop()"
      [language]="language">
    </formio>
 </div>

 <div class="float-right m3-3">
    <re-captcha
      #captchaRef="reCaptcha"
      (resolved)="resolved($event)"
      (error)="onError($event)"
      errorMode="handled"
    ></re-captcha>
Versione: {{versione}}
 </div>
